import { object, preprocess } from 'zod';

import {
  LimitDisabledSchemaWithIsEnabled,
  LimitSchema,
  TransactionLimitDisabledSchemaWithIsEnabled,
  TransactionLimitSchema,
  transactionFrequencyLimitSchema,
  validateMembershipLessThanGlobal,
} from '@occc/feat-limits';
import { withIsEnabled } from '@occc/validation';

const AwardCountEnabledWithTransactionSchema = object({
  membership: LimitSchema,
  global: LimitSchema,
  transaction: TransactionLimitSchema.optional(),
  transactionFrequency: transactionFrequencyLimitSchema,
}).superRefine((data, ctx) => {
  validateMembershipLessThanGlobal({
    membership: data.membership,
    global: data.global,
    ctx,
  });
});

const AwardCountDisabledWithTransactionSchema = object({
  membership: preprocess(() => ({}), LimitDisabledSchemaWithIsEnabled),
  global: preprocess(() => ({}), LimitDisabledSchemaWithIsEnabled),
  transaction: preprocess(
    (value) => (value == null ? undefined : {}),
    TransactionLimitDisabledSchemaWithIsEnabled.optional(),
  ),
  transactionFrequency: preprocess(() => ({}), transactionFrequencyLimitSchema),
});

export const AwardCountSchema = withIsEnabled(
  AwardCountEnabledWithTransactionSchema,
  AwardCountDisabledWithTransactionSchema,
);

const AwardCountEnabledSchema = object({
  membership: LimitSchema,
  global: LimitSchema,
}).superRefine((data, ctx) => {
  validateMembershipLessThanGlobal({
    membership: data.membership,
    global: data.global,
    ctx,
  });
});

const AwardCountDisabledSchema = object({
  membership: preprocess(() => ({}), LimitDisabledSchemaWithIsEnabled),
  global: preprocess(() => ({}), LimitDisabledSchemaWithIsEnabled),
});

export const AwardCountWithoutTransactionSchema = withIsEnabled(
  AwardCountEnabledSchema,
  AwardCountDisabledSchema,
);

const AwardCountWithTransactionFrequencyEnabledSchema = object({
  membership: LimitSchema,
  global: LimitSchema,
  transactionFrequency: transactionFrequencyLimitSchema,
}).superRefine((data, ctx) => {
  validateMembershipLessThanGlobal({
    membership: data.membership,
    global: data.global,
    ctx,
  });
});

const AwardCountWithTransactionFrequencyDisabledSchema = object({
  membership: preprocess(() => ({}), LimitDisabledSchemaWithIsEnabled),
  global: preprocess(() => ({}), LimitDisabledSchemaWithIsEnabled),
  transactionFrequency: preprocess(() => ({}), transactionFrequencyLimitSchema),
});

export const AwardCountWithTransactionFrequencyOnlySchema = withIsEnabled(
  AwardCountWithTransactionFrequencyEnabledSchema,
  AwardCountWithTransactionFrequencyDisabledSchema,
);
